export default {
	checkboxValue (state) {
		return report => !!state.selected[report.id];
	},
	headCheckboxValue (state) {
		return !!(state.list.length && Object.keys(state.selected).length === state.list.length);
	},
};
